"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SerieTags = void 0;
/**
 * Defines the ArticleSpecs (multi-selection possible)
 */
var SerieTags;
(function (SerieTags) {
    // smart plastics
    SerieTags["SmartPlasticsECWAllowed"] = "SmartPlasticsECWAllowed";
})(SerieTags = exports.SerieTags || (exports.SerieTags = {}));
//# sourceMappingURL=SerieTags.js.map